import { render, staticRenderFns } from "./Ticimax.vue?vue&type=template&id=23be9dce&scoped=true&"
import script from "./Ticimax.vue?vue&type=script&lang=js&"
export * from "./Ticimax.vue?vue&type=script&lang=js&"
import style0 from "./Ticimax.vue?vue&type=style&index=0&id=23be9dce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23be9dce",
  null
  
)

export default component.exports